<template>
    <div class="circle-image">
        <h3
            v-if="title"
            class="title"
        >
            {{ title }}
        </h3>
        <div :class="'image-wrapper' + (isDisabled ? ' disabled' : '')">
            <img
                class="image"
                :src="image"
            >
            <div class="text">
                {{ text }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CircleImage',
    components: {},
    props: {
        text: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
});
</script>

<style lang="postcss" scoped>
.circle-image {
    @apply capitalize;

    .title {
       @apply font-bold mb-4;
    }

    .image-wrapper {
        @apply flex flex-col relative justify-end w-detail-circle-image h-detail-circle-image text-center;

        &.disabled {
            .image {
                @apply opacity-50;
                filter: grayscale(100%);
            }

            .text {
                @apply text-black;
            }
        }

        .image {
            @apply rounded-full overflow-hidden w-full h-full;
            border: 1px solid #666;
        }

        .text {
            @apply absolute font-bold text-white text-lg;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
